<template>
  <div id="compliancedetails" style="text-transform: capitalize;">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="datepickerwrap card revampCard" style="flex-direction: row">
      <div class="leftcontent wrapitem" style="width:80%">
        <div class="datebox" style="width:12%">
          <datepicker
            :disabled="{ to: moment('2022-03-24', 'YYYY-MM-DD').toDate(), from: moment().subtract(1, 'days').toDate() }"
            placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
        </div>
        <div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
            <option value="https://www.hp.com/in-en">HP India</option>
            <option value="https://www.hp.com/in-en#commercial">Commercial HP India</option>
          </select>
        </div>
        <div class="datebox" style="width:10%">
          <select v-model="device" @change="refresh" class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
          </select>
        </div>
        <div class="datebox" style="width: fit-content">
          <button @click="refresh" class="btn primarycolor" type="button">Submit</button>
        </div>
        <div v-if="showReport" class="datebox" style="width: fit-content">
          <button @click="goToComReport" class="navigationButton" type="button">
            Nomenclature Report
          </button>
        </div>
        <div v-if="showMsging" class="datebox" style="width: fit-content">
          <button @click="goToMessaging" class="navigationButton" type="button">
            Messaging Report
          </button>
        </div>
      </div>
      <div class="wrapitem righcontent" style="width: 20%">
        <div class="datebox" style="float: right">
          <button @click="backToSov" style="width: max-content; float: right" class="navigationButton" type="button">
            <i class="fa fa-arrow-left backIcon"></i>
            <span> Back</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid ">
      <div class="">
        <div class="card revampCard p-2">
          <div class="space-between-header border-0">
            <h4 class="badgeColor">AMD {{ deviceMapper[device] }} Compliance: {{ selectedWebComplianceScore }}
            </h4>
          </div>

          <table id="myTable2" v-if="rows_details.length" class="table"
            style="transform: rotateX(180deg);">
            <thead class="thead-normal">
              <tr>
                <th>SKU</th>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label }} </th>
                <th v-for="d in columnsAudit" :key="d.field">
                  {{ d.label }}
                </th>
              </tr>
              <tr>
              <th></th>
              <th v-for="d in columns_details" :key="d.field"></th>
              <th v-for="d in columnsAudit" :key="d.field">
                <span v-if="d.field == 'compliance_score'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.comScore">?</b-btn>
                  </span>
                  <span v-if="d.field == 'position_score'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.pscore">?</b-btn>
                  </span>
                  <span v-if="d.field == 'sku_score'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.sku">?</b-btn>
                  </span>
                  <span v-if="d.field == 'rating_score'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.ratingScore">?</b-btn>
                  </span>
                  <span v-if="d.field == 'category_position'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.cpos">?</b-btn>
                  </span>
                  <span v-if="d.field == 'category_13_position'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.cat13Pos">?</b-btn>
                  </span>
                  <span v-if="d.field == 'search_position'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.tooltip.spos">?</b-btn>
                  </span>
                  <span v-if="d.field == 'search_13_position'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.s13pos">?</b-btn>
                  </span>
                  <span v-if="d.field == 'logo'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.plogo">?</b-btn>
                  </span>
                  <span v-if="d.field == 'image_count'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.imgCount">?</b-btn>
                  </span>
                  <span v-if="d.field == 'product_nomenclature'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.psnomen">?</b-btn>
                  </span>
                  <span v-if="d.field == 'hero_nomenclature'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.hbnomen">?</b-btn>
                  </span>
                  <span v-if="d.field == 'nomenclature'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.nomen">?</b-btn>
                  </span>
                  <span v-if="d.field == 'other_nomenclature'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.onomen">?</b-btn>
                  </span>
                  <span v-if="d.field == 'message'">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.msg">?</b-btn>
                  </span>
              </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
              <tr>
                <th><span>SKU</span></th>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
                <th v-for="d in columnsAudit" :key="d.field">{{ d.label }}</th>
              </tr>
            </tfoot>
            <tbody class="tbody-normal">
              <tr v-for="(r, i) in rows_details" :key="i" v-if="r['processor'] == 'amd'">
                <td><span>{{ r.audit['sku'] }}</span></td>
                <td v-for="d in columns_details" :key="d.field" :class="{ 'minWid': d.field == 'product_name' }">
                  <span v-if="d.field == 'product_name'"><a target="_blank" :href="r['link']">{{ r[d.field]
                      }}</a></span>
                  <span v-else-if="d.field == 'processor'" style="text-transform:uppercase">{{ r[d.field] }}</span>
                  <span v-else>{{ r[d.field] }}</span>
                </td>
                <td v-for="d in columnsAudit" :key="d.field">
                  <span>{{ r.audit[d.field] }}</span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>
<script>""
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'compliancedetails',
  components: { Datepicker },
  data: function () {
    return {
      moment: moment,
      selected_website: localStorage.selected_website,
      device: 'laptop',
      date: {
        startDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
      },
      columns_details: [
        { label: 'Name', field: 'product_name', sortable: false },
        { label: 'Brand', field: 'brand', sortable: false },
        { label: 'Processor Type', field: 'processor_type', sortable: false },
        { label: 'Processor Model', field: 'processor_model', sortable: false },
        { label: 'Ratings', field: 'ratings' }
      ],
      rows: [],
      rows_details: [],
      oem_websites: ['https://www.hp.com/in-en', 'https://www.hp.com/in-en#commercial'],
      comChart: {},
      activeComChart: false,
      page: 1,
      showAuditModal: false,
      brand_data: {},
      columnsAudit: [],

      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      selectedWebComplianceScore: '',
      deviceMapper: {
        'laptop': 'PC',
        'desktop': 'Desktop'
      },
      tooltip: {
        comScore: '',
        sku: '',
        ratingScore: '',
        plogo: '',
        nomen: '',
        msg: '',
        pscore: '(100 - Category Position) \n if Category Position < 100, \n 0 if Category Position > 100',
        cpos: 'Position In Category Page',
        cat13Pos: '1: If System in page 1 of results \n 2: if System in page 2-3 of results \n 3: if System not in pages 1-3',
        spos: 'Position in on-site search',
        s13pos: '1: If System in page 1 of search results \n 2: if System in page 2-3 of search results \n 3: if System not in pages 1-3',
        imgCount: '1: 3 or more product images \n 2: 2 more product images \n 3: 0 or 1 product images'
      },
      segData: {},
      showReport: false,
      showSegment: false,
      isOEM: false,
      newDetails: false,
      commercialSites: ['https://www.hp.com/in-en#commercial'],
      comReportSites: [
        'https://www.hp.com/in-en#commercial',
        'https://www.hp.com/in-en'
      ],
      showMsging: false,
      msgingSites: [
        'https://www.hp.com/in-en#commercial',
        'https://www.hp.com/in-en'
      ]
    }
  },
  watch: {
    newDetails() {
      if (this.newDetails) {
        this.showReport = true
        this.showMsging = true
      }
    }
  },
  mounted() {
    this.initCols()
    // if(this.oem_websites.includes(this.selected_website))
    //   this.getSegment()
    this.website_details()
    if (this.comReportSites.includes(this.selected_website))
      this.showReport = true
    else
      this.showReport = false
    if (this.msgingSites.includes(this.selected_website))
      this.showMsging = true
    else
      this.showMsging = false

    if (this.selected_website.includes('commercial')) {
      this.showReport = true
      this.showMsging = true
    }
  },
  methods: {
    goToMessaging() {
      window.location = '#/messaging-report-amd-india'
    },
    goToComReport() {
      window.location = '#/compliance-report-amd-india'
    },
    exportComp() {
      let self = this
      let payload = {
        header: [{ key: 'sku', label: 'SKU' }, { key: 'link', label: 'Link' }],
        data: [],
        file_type: 'compliance'
      }
      for (let [idx, ds] of self.columns_details.entries()) {
        payload.header.push({ key: ds.field, label: ds.label })
      }
      for (let [idx, ds] of self.columnsAudit.entries()) {
        payload.header.push({ key: ds.field, label: ds.label })
      }
      for (let [idx, ds] of self.rows_details_full.entries()) {
        if (ds.processor == 'amd') {
          if (idx == 0) {
            let csvFirstRow = self.getTooltipRow(ds)
            payload.data.push(csvFirstRow)
          }
          payload.data.push(ds)
        }
      }
      const url = "/api/websites/export"
      self.$http.post(url, payload).then(response => {
        window.location = response.body.file
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    getTooltipRow(row) {
      let self = this
      let tooltipkeyMapper = {
        'compliance_score': 'comScore',
        'hero_nomenclature': 'hbnomen',
        'message': 'msg',
        'nomenclature': 'nomen',
        'other_nomenclature': 'onomen',
        'logo': 'plogo',
        'product_nomenclature': 'psnomen',
        'rating_score': 'ratingScore',
        'sku_score': 'sku',
        'position_score': 'pscore',
        'category_position': 'cpos',
        'category_13_position': 'cat13Pos',
        'search_position': 'spos',
        'search_13_position': 's13pos',
        'image_count': 'imgCount'
      }
      let obj = {}
      obj['audit'] = {}
      let keys1 = Object.keys(row)
      for (let [idx, ds] of keys1.entries()) {
        if (ds != 'audit')
          obj[ds] = self.tooltip[tooltipkeyMapper[ds]] || ''
      }
      let keys2 = Object.keys(row.audit)
      for (let [idx, ds] of keys2.entries()) {
        obj.audit[ds] = self.tooltip[tooltipkeyMapper[ds]] || ''
      }
      return obj
    },
    formatTradeMarkString(s) {
      return s.replace(/#/g, '™').replace(/\$/g, '® ').replace(/<>/g, '  ')
    },
    exportAll() {
      let self = this
      let payload = {
        header: [
          { "key": "sku", "label": "SKU" },
          { "key": "link", "label": "Link" },
          { "key": "product_name", "label": "Name" },
          { "key": "brand", "label": "Brand" },
          { "key": "processor_type", "label": "Processor Type" },
          { "key": "processor_model", "label": "Processor Model" },
          { "key": "ratings", "label": "Ratings" },
          { "key": "rating_score", "label": "Rating Score" },
          { "key": "logo", "label": "AMD Badges" },
          { "key": "product_nomenclature", "label": "Product Specs Nomenclature" },
          { "key": "product_text", "label": "Product Specs Text On Site" },

          { "key": "product_text_comment", "label": "Product Text Comment" },
          { "key": "product_text_match", "label": "Correct Product Specs Text" },

          { "key": "hero_nomenclature", "label": "Hero Banner Nomenclature" },
          { "key": "hero_text", "label": "Hero Banner Text On Site" },

          { "key": "hero_text_comment", "label": "Hero Text Comment" },
          { "key": "hero_text_match", "label": "Correct Hero Banner Text" },

          { "key": "other_nomenclature", "label": "Other Nomenclature" },
          { "key": "other_text", "label": "Other Text On Site" },

          { "key": "other_text_comment", "label": "Other Text Comment" },
          { "key": "other_text_match", "label": "Correct Other Text" },

          { "key": "nomenclature", "label": "Nomenclature" }
        ],
        data: [],
        file_type: 'compliance'
      }
      for (let [idx, ds] of this.rows_details[0].audit.messaging.entries()) {
        payload.header.push({ key: 'messaging_' + 'score_' + ds.index, label: 'Messaging Section ' + ds.index + ' Score' })
        payload.header.push({ key: 'messaging_' + 'message_' + ds.index, label: 'Messaging Section ' + ds.index + ' on Site' })
        payload.header.push({ key: 'messaging_' + 'comment_' + ds.index, label: 'Messaging Section ' + ds.index + ' Comment' })
      }
      payload.header.push({ "key": "messaging_match", "label": "Correct Text" }, { "key": "message", "label": "Overall Messaging Score" })
      for (let [idx, ds] of self.rows_details_full.entries()) {
        if (ds.processor == 'amd') {
          for (let [indx, dataset] of ds.audit.messaging.entries()) {
            ds['messaging_' + 'score_' + dataset.index] = dataset.score
            ds.audit['messaging_' + 'score_' + dataset.index] = dataset.score
            if (dataset.heading) {
              ds['messaging_' + 'message_' + dataset.index] = this.formatTradeMarkString(dataset.heading) + ': ' + this.formatTradeMarkString(dataset.message)
              ds.audit['messaging_' + 'message_' + dataset.index] = this.formatTradeMarkString(dataset.heading) + ': ' + this.formatTradeMarkString(dataset.message)
            }
            else {
              ds['messaging_' + 'message_' + dataset.index] = this.formatTradeMarkString(dataset.message)
              ds.audit['messaging_' + 'message_' + dataset.index] = this.formatTradeMarkString(dataset.message)
            }
            ds['messaging_' + 'comment_' + dataset.index] = this.formatTradeMarkString(dataset.comment)
            ds.audit['messaging_' + 'comment_' + dataset.index] = this.formatTradeMarkString(dataset.comment)
          }
          for (let [indx, dataset] of payload.header.entries()) {
            if (dataset.key.includes('text')) {
              ds.audit[dataset.key] = this.formatTradeMarkString(ds.audit[dataset.key])
            }
          }
          if (idx == 0) {
            let csvFirstRow = self.getTooltipRow(ds)
            payload.data.push(csvFirstRow)
          }
          payload.data.push(ds)
        }
      }
      payload.header.push({ "key": "compliance_score", "label": "Compliance Score" }, { "key": "sku_score", "label": "SKU Score" })
      const url = "/api/websites/export"
      self.$http.post(url, payload).then(response => {
        window.location = response.body.file
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    getSegment() {
      let self = this
      self.loader = true
      let payload = {
        "website": this.selected_website,
        "item_category": self.device,
      }
      const url = "/api/websites/website_check"
      self.$http.post(url, payload).then(response => {
        self.segData = response.body
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
    initCols() {
      let self = this
      if (this.oem_websites.includes(this.selected_website)) {
        this.isOEM = true
        this.tooltip.ratingScore = '(Rating/5)*100'
        this.tooltip.plogo = '1: Correct AMD Badges \n 2: Incorrect AMD Badges \n 3: No AMD Badges'
        this.tooltip.psnomen = '1: Complete & Correct AMD Nomenclature \n 2: Incomplete AMD Nomenclature \n 3: Incorrect AMD Nomenclature \n N/A: Missing AMD Nomenclature'
        this.tooltip.hbnomen = '1: Complete & Correct AMD Nomenclature \n 2: Incomplete AMD Nomenclature \n 3: Incorrect AMD Nomenclature \n N/A: Missing AMD Nomenclature'
        this.tooltip.nomen = 'Product Specs Nomenclature, if Hero Banner Nomenclature = N/A \n (Product Specs Nomenclature + Hero Banner Nomenclature) /2'
        this.tooltip.onomen = '1: Complete & Correct AMD Nomenclature \n 2: Incomplete AMD Nomenclature \n 3: Incorrect AMD Nomenclature \n N/A: Missing AMD Nomenclature'
        this.tooltip.msg = '1: Correct AMD Messaging \n 2: Incorrect AMD Messaging \n 3: No AMD Messaging'
        this.showSegment = true
        this.tooltip.comScore = '((6-( SUM(Nomenclature + Message)))/4)*100'
        this.tooltip.sku = '(SUM(Compliance Score  + Rating Score))/2'
        // let oemList1 = ["https://www.lenovo.com/us","https://www.lenovo.com/gb","https://www.lenovo.com/de","https://store.hp.com/UKStore","https://store.hp.com/us","https://www.dell.com/en-us","https://store.asus.com/us"]
        let customSites = [
          'https://store.hp.com/mx-es',
          'https://www8.hp.com/jp',
          'https://br-store.acer.com',
          'https://www.lenovo.com/gb#commercial',
          'https://s.lenovo.com.cn',
          'https://fmv.fccl.fujitsu.com',
          'https://www.nec-lavie.jp'
        ]
        if (customSites.includes(self.selected_website)) {
          this.tooltip.comScore = '((9-(SUM(AMD Badges  + Nomenclature + Message)))/6)*100'
        }
        let cScore3Sites = [
          'https://www.bechtle.com',
        ]
        if (cScore3Sites.includes(self.selected_website)) {
          this.tooltip.comScore = '((3-NOMENCLATURE)/2)x 100'
        }

        this.columnsAudit = [
          { label: 'Rating Score', field: 'rating_score', sortable: false },
          { label: 'AMD Badges', field: 'logo', sortable: false },
          { label: 'Product Specs Nomenclature', field: 'product_nomenclature', sortable: false },
          { label: 'Hero Banner Nomenclature', field: 'hero_nomenclature', sortable: false },
          { label: 'Other Nomenclature', field: 'other_nomenclature', sortable: false },
          { label: 'Nomenclature', field: 'nomenclature', sortable: false },
          { label: 'Message', field: 'message', sortable: false },
          { label: 'Compliance Score', field: 'compliance_score', sortable: false },
          { label: 'SKU Score', field: 'sku_score', sortable: false },
        ]

        if (self.commercialSites.includes(self.selected_website) && !self.newDetails) {
          this.tooltip.nomen = '1: Correct AMD Nomenclature \n 2: Incorrect AMD Nomenclature \n 3: No AMD Nomenclature'
          this.columnsAudit = [
            { label: 'Rating Score', field: 'rating_score', sortable: false },
            { label: 'AMD Badges', field: 'logo', sortable: false },
            { label: 'Nomenclature', field: 'nomenclature', sortable: false },
            { label: 'Message', field: 'message', sortable: false },
            { label: 'Compliance Score', field: 'compliance_score', sortable: false },
            { label: 'SKU Score', field: 'sku_score', sortable: false },
          ]
        }
      }
      else {
        this.isOEM = false
        this.tooltip.ratingScore = '(Rating/5)*100'
        this.tooltip.plogo = '1: Correct AMD Badges \n 2: Incorrect AMD Badges \n 3: No AMD Badges'
        this.tooltip.nomen = '1: Correct AMD Nomenclature \n 2: Incorrect AMD Nomenclature \n 3: No AMD Nomenclature'
        this.tooltip.msg = '1: Correct AMD Messaging \n 2: Incorrect AMD Messaging \n 3: No AMD Messaging'
        this.showSegment = false
        this.tooltip.comScore = '((12-(SUM(AMD Badges + Product Images + Nomenclature + Message)))/8)*100'
        this.tooltip.sku = '(SUM(Compliance Score + Position Score + Rating Score))/3'
        this.columnsAudit = [
          { label: 'Rating Score', field: 'rating_score', sortable: false },
          { label: 'AMD Badges', field: 'logo', sortable: false },
          { label: 'Product Images', field: 'image_count', sortable: false },
          { label: 'Nomenclature', field: 'nomenclature', sortable: false },
          { label: 'Message', field: 'message', sortable: false },
          { label: 'Compliance Score', field: 'compliance_score', sortable: false },
          { label: 'Category Position', field: 'category_position', sortable: false },
          { label: 'Category page position (1-3)', field: 'category_13_position', sortable: false },
          // {label: 'Search Position', field: 'search_position',sortable: false},
          // {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false},
          { label: 'Position Score', field: 'position_score', sortable: false },
          { label: 'SKU Score', field: 'sku_score', sortable: false },
        ]
      }
    },
    backToSov() {
      window.location = '#/sov-summary-amd'

    },
    showHeroChange() {
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (self.isHero) {
          if (dataset.is_hero) {
            this.rows_details.push(dataset)
          }
        }
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function () {
        self.initDt2()
      })
    },

    openAuditModal(r) {
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },

    format(v) {
      return this.$options.filters.format(v)
    },
    refresh() {
      $('#myTable2').DataTable().destroy();
      this.initCols()
      if (this.oem_websites.includes(this.selected_website))
        this.getSegment()
      if (this.comReportSites.includes(this.selected_website))
        this.showReport = true
      else
        this.showReport = false
      if (this.msgingSites.includes(this.selected_website))
        this.showMsging = true
      else
        this.showMsging = false

      if (this.selected_website.includes('commercial')) {
        this.showReport = true
        this.showMsging = true
      }
      localStorage.selected_website = this.selected_website
      localStorage.selected_category = this.device
      this.website_details()
    },
    drawComChart() {
      let self = this
      let categories = []
      let data1 = []
      let arr = []
      let highlight_color = ''
      let min_com = 0
      let com_data = []

      for (const [key, value] of Object.entries(self.brand_data)) {

        com_data.push({ 'website': key, 'score': value })
      }

      let sortedArr = com_data.sort((a, b) => a.score - b.score);
      for (let [idx, dataset] of sortedArr.entries()) {
        if (dataset.website == "hp")
          dataset.website = "HP"
        if (sortedArr.length == 1) {
          categories.push(dataset.website)
        }
        else {
          if (idx == 0)
            categories.push(dataset.website + '<br/> <b>(Least Compliant)</b>')
          else if (idx == sortedArr.length - 1)
            categories.push(dataset.website + '<br/> <b>(Most Compliant)</b>')
          else
            categories.push(dataset.website)
        }
        data1.push(dataset.score)
      }

      self.comChart = {
        chart: {
          type: 'column',
          height: 230,
          marginTop: 45
        },
        title: {
          text: ' '
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: categories,
          title: {
            text: 'OEM'
          }
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              style: { fontWeight: 0 },
              formatter: function () {
                return this.point.y
              },
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Compliance Score',

          },
        },
        tooltip: {
          shared: true,
          enabled: false
        },

        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          name: '',
          data: data1,
          // color: '#8a87e8',
          pointWidth: 60,
          dataSorting: {
            enabled: true
          },

        }]
      }
      setTimeout(function () {
        self.activeComChart = true
      }, 0)
    },
    website_details() {
      let self = this
      self.loader = true
      self.rows_details = []
      self.rows_details_full = []
      let url = "/api/amazon_india/oem_details"
      self.activeComChart = false
      let payload = { "website": this.selected_website, "timestamp": this.date.startDate }
      payload['item_category'] = self.device
      this.$http.post(url, payload).then(response => {
        self.newDetails = response.body.new_details
        if (this.newDetails) {
          this.showReport = true
          this.showMsging = true
        }
        self.initCols()
        self.brand_data = response.body.brand_data
        self.selectedWebComplianceScore = response.body.final_compliance_score
        if (!this.isOEM)
          self.drawComChart()
        for (let [idx, ds] of response.body.data.entries()) {
          if (ds.brand.indexOf('hp') != -1) ds.brand = ds.brand.replace('hp', 'HP')
          if (ds.processor_type.indexOf('amd') != -1) ds.processor_type = ds.processor_type.replace('amd', 'AMD')
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function () {
          self.initDt2()
        })

      }, err => {
        self.loader = false
      });
    },

    changeCustomDate() {
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
    initDt2() {
      let self = this
      $('#myTable2').DataTable({
        autoWidth: false,
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
        // dom: '<"top">frt<"bottom"l>p<"clear">',
        pagingType: "full_numbers",
        // info: false,
        initComplete: function () {
          this.api().columns().every(function () {
            var column = this;
            var select = $("<select><option value=''>All</option></select>")
              .appendTo($(column.footer()).empty())
              .on('change', function () {
                var val = $.fn.dataTable.util.escapeRegex(
                  $(this).val()
                );
                column
                  .search(val ? '^' + val + '$' : '', true, false)
                  .draw();
              });
            let arr = []
            let sortedArr = []
            column.data().unique().sort().each(function (d, j) {
              // console.log(d) 
              if (d == 'N/A') d = 'Na'
              var myVal = $(d).text()

              arr.push(myVal)
            });

            sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, { numeric: true, ignorePunctuation: true }))
            for (let [idx, ds] of sortedArr.entries()) {
              select.append("<option value='" + ds + "'>" + ds + "</option>")
            }
          });
        }
      });
      var search = require("../../../public/Icons_SVG/Search.svg");
      $('#myTable2').wrap("<div class='scrolledDataTable'></div>");
      $("#myTable2_filter > label > input").attr(
        "placeholder",
        "Search"
      );
      $("#myTable2_filter > label").append(
        `<div><img src='${search}' /></div>`
      );
      $("#myTable2_length > label > select").removeClass();
    }
  }
}

</script>

<style scoped>
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important
}

.markitintel {
  background-color: #c7e0ff !important;
}

.markitsnap {
  background-color: #ffd0f5 !important
}

.markitna {
  background-color: #edf2fb !important
}

.markittek {
  background-color: #fff0ce !important
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}

.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}

.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999
}

.amd-legend i {

  width: fit-content;
}

.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}

.legending {
  display: inline-block;
  margin-right: 19px;
}

#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px
}

.mycols:first-child {
  padding-right: 2px !important
}

.mycols:last-child {
  padding-left: 2px
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px
}

.minWid {
  min-width: 250px;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
}
.badgeColor {
  font-weight: bold;
  color: #47a694;
  margin: 0px;
  font-size: 18px;
  letter-spacing: 0.2px;
}
.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%)
    hue-rotate(268deg) brightness(116%) contrast(100%);
}
.hint{
    cursor: pointer;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4e4e4e;
    border: 1px solid #4e4e4e;
    border-radius: 3px;
    padding: 3px;
    width: 17px;
    height: 17px;
    font-size: 12px;
}
</style>
<style>
#myTable2_wrapper .scrolledDataTable{
  border-left: 0 !important;
  border-right: 0 !important;
}

#myTable2 th select {
    background-color: #fff!important;
    filter: brightness(99%);
    border: 1px solid #b1b1b1!important;
    width: 100%;
    color: var(--primary_brand-60);
    font-size: 10px;
    border-radius: 7px;
    height: 33px;
}

#myTable2 tfoot th:first-child {
    background-color: var(--background)!important;
    border-left: 1px solid var(--base_color-20)!important;
    padding: 5px!important;
}
#myTable2 tfoot th {
    background-color: var(--background)!important;
    border-right: 1px solid var(--base_color-20)!important;
    border-bottom: 1px solid var(--base_color-20)!important;
    padding: 5px!important;
}
#myTable2 .thead-normal>tr:last-child>th {
    font-size: 14px;
    letter-spacing: .1px;
    font-weight: 300!important;
    text-align: center!important;
    padding: 0 25px 5px 25px!important;
    color: #4e4e4e!important;
    border-right: 1px solid var(--base_color-20)!important;
}

#myTable2 .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 150%;
  color: var(--base_color-80);
}

#myTable2 .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  top: -30%;
  color: var(--base_color-80);
}
#myTable2_info{
  font-size: 15px !important;
  color: var(--primary_brand-80);
}

#myTable2_filter img {
    height: 17px;
    filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}
#myTable2_filter div {
    height: 35px;
    width: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-left: -3px;
    background-color: var(--primary_brand);
}
#myTable2_filter input {
    border-radius: 5px 0 0 5px!important;
    height: 35px;
    width: 220px;
    margin-bottom: 8px;
    outline: none;
    border-color: var(--primary_brand-60);
    border-right: none;
    padding: 10px 15px!important;
}
#myTable2_length select {
    width: 30px;
    height: 100%;
    text-align-last: center;
    border-radius: 5px;
    margin-right: 10px!important;
    -webkit-appearance: none!important;
    -moz-appearance: none!important;
    appearance: none!important;
    border-color: var(--primary_brand-40)!important;
    background-color: #fff!important;
    color: var(--primary_brand-80);
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}
</style>
